import { render, staticRenderFns } from "./CriticalitiesListFilters.vue?vue&type=template&id=83c224fa&scoped=true&"
import script from "./CriticalitiesListFilters.vue?vue&type=script&lang=js&"
export * from "./CriticalitiesListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CriticalitiesListFilters.vue?vue&type=style&index=0&id=83c224fa&lang=scss&scoped=true&"
import style1 from "./CriticalitiesListFilters.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c224fa",
  null
  
)

export default component.exports